import React, { useState, useCallback } from "react";
import styled from "styled-components";
import { ExpandableArea } from "./ExpandableArea";

export interface FaqItemProps {
  question: string;
  answer: string;
}

export function FaqItem({ question, answer }: FaqItemProps) {
  const [expanded, setExpanded] = useState(false);
  const handleToggleExpand = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <FaqContainer
      itemProp="mainEntity"
      itemScope
      itemType="https://schema.org/Question"
    >
      <QuestionTextButton
        onClick={handleToggleExpand}
        $expanded={expanded}
        itemProp="name"
      >
        {question}
      </QuestionTextButton>
      <ExpandableArea expanded={expanded}>
        <div
          itemProp="acceptedAnswer"
          itemScope
          itemType="https://schema.org/Answer"
        >
          <AnswerStyledText
            dangerouslySetInnerHTML={{ __html: answer }}
            itemProp="text"
          />
        </div>
      </ExpandableArea>
      <noscript dangerouslySetInnerHTML={{ __html: answer }} />
    </FaqContainer>
  );
}

const FaqContainer = styled.div`
  margin-bottom: 28px;
`;

const QuestionTextButton = styled.h3<{ $expanded: boolean }>`
  background-color: transparent;
  color: ${(props) => props.theme.color.primarySubtle};
  cursor: pointer;
  border: none;
  font-size: 1.5rem;
  text-align: left;
  padding: 0;
  :hover,
  :focus {
    color: #346f20;
  }
  ::before {
    content: ${(props) => (props.$expanded ? `"-  "` : `"+  "`)};
    font-family: monospace;
  }
`;

const AnswerStyledText = styled.div`
  p {
    font-size: 1.25rem !important;
    font-weight: 300 !important;
    color: black;
  }
`;
